import { Modal } from 'antd'
import MoneyCell from '../../../../../../elements/Table/Cells/MoneyCell'
import StatusCell from '../../../../../../elements/Table/Cells/StatusCell'
import CustomTable from '../../../../../../elements/Table/CustomTable'
import React from 'react'
import { Link } from 'react-router-dom'
import SumFooter from '../../../../../../elements/Table/Footers/SumFooter'

function VendorList(props) {
  const { list, submitting, visible, onCancel, type } = props
  console.log(props)
  const columns = {
    purchases: [
      {
        Header: 'Code',
        accessor: 'code',
        width: 200,
        Cell: ({ value, original }) => (
          <Link target={'_blank'} to={`/purchasing/Order/${original._key}/update`}>
            {value}
          </Link>
        ),
      },
      {
        Header: 'Purchases ID',
        accessor: '_id',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Title',
        accessor: 'title',
        style: { paddingLeft: 20, alignment: 'left' },
        hideable: true,
        hideDefault: false,
      },
      {
        Header: 'Company',
        accessor: 'company.fn',
        style: { paddingLeft: 20, alignment: 'left' },
        hideable: true,
        hideDefault: true,
      },
      { Header: 'Type', accessor: 'type' },
      {
        Header: 'Category',
        accessor: 'category',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Currency',
        accessor: 'currency',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Amount',
        accessor: 'amount',
        Cell: ({ value, original }) => MoneyCell({ value, currency: original.currency }),
      },
      {
        Header: 'Converted (USD)',
        accessor: 'amountUSD',
        Cell: ({ value }) => MoneyCell({ value, currency: 'USD' }),
        Footer: SumFooter,
      },

      { Header: 'Status', accessor: 'status', Cell: StatusCell },
    ],
    rfq: [
      {
        Header: 'RFQ Code',
        accessor: 'code',
        width: 170,
        Cell: ({ value, original }) => (
          <Link
            to={{
              pathname: `/purchasing/rfq/${original._key}/update`,
            }}>
            {value}
          </Link>
        ),
      },
      {
        Header: 'RFQ ID',
        accessor: '_id',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Enquiry',
        accessor: 'enquiry.code',
        width: 170,
        hideable: true,
        hideDefault: false,
      },
      {
        Header: 'Title',
        accessor: 'title',
        style: { textAlign: 'left' },
      },
      {
        Header: 'Company',
        accessor: 'company.fn',
        style: { paddingLeft: 20, alignment: 'left' },
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Issued',
        accessor: 'issuance.issued',
        width: 170,
        Cell: ({ value }) => value === true && <span>Issued</span>,
      },
      { Header: 'Status', accessor: 'status', width: 170, Cell: StatusCell },
    ],
    vendorQuote: [
      {
        Header: 'Vendor Quote No',
        accessor: 'quoteNo',
        width: 200,
        Cell: ({ value, original }) => (
          <Link
            to={{
              pathname: `/purchasing/vendor/quotes/${original._key}/update`,
            }}
            target={'_blank'}>
            {value}
          </Link>
        ),
      },
      {
        Header: 'VQ ID',
        accessor: '_id',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Title',
        accessor: 'title',
        style: { textAlign: 'left', marginLeft: 5 },
      },
      {
        Header: 'Company',
        accessor: 'company.fn',
        style: { paddingLeft: 20, alignment: 'left' },
        hideable: true,
        hideDefault: true,
      },
      { Header: 'Currency', accessor: 'currency' },
      { Header: 'Status', accessor: 'status', width: 150, Cell: StatusCell },
    ],
  }
  return (
    <Modal visible={visible} title={type.toUpperCase()} onCancel={onCancel} destroyOnClose={true} width={'75%'}>
      <CustomTable
        data={list}
        defaultPageSize={20}
        isFilterable={true}
        show={{ csv: { fileName: `Vendor-Report` } }}
        fetching={submitting}
        columns={columns[type]}
      />
    </Modal>
  )
}

export default VendorList
